import { Controller } from "@hotwired/stimulus"

// Handles notification display functionality
export default class extends Controller {
  static targets = ["container", "message"]

  connect() {
    // No longer auto-hiding notifications
    // User must manually close notifications via the X button
  }
  
  // Hide the notification
  hide() {
    if (!this.hasContainerTarget) return
    
    // Fade out then remove
    this.containerTarget.classList.add("opacity-0")
    setTimeout(() => {
      this.containerTarget.remove()
    }, 500)
  }
  
  // Show a notification with a message and success/error styling
  show(message, success = true) {
    if (!this.hasContainerTarget || !this.hasMessageTarget) return
    
    this.messageTarget.textContent = message
    this.containerTarget.classList.remove("hidden", "opacity-0")
    this.containerTarget.classList.add("opacity-100")
    
    // Apply appropriate styling based on success/failure
    this.containerTarget.classList.remove(
      "bg-green-100", "border-green-500", "text-green-700",
      "bg-red-100", "border-red-500", "text-red-700"
    )
    
    if (success) {
      this.containerTarget.classList.add("bg-green-100", "border-green-500", "text-green-700")
      
      // Update the SVG color for success
      const svgElement = this.containerTarget.querySelector('svg')
      if (svgElement) {
        svgElement.classList.remove("text-red-500")
        svgElement.classList.add("text-green-500")
      }
    } else {
      this.containerTarget.classList.add("bg-red-100", "border-red-500", "text-red-700")
      
      // Update the SVG color for error
      const svgElement = this.containerTarget.querySelector('svg')
      if (svgElement) {
        svgElement.classList.remove("text-green-500")
        svgElement.classList.add("text-red-500")
      }
    }
    
    // Hide notification after 5 seconds
    setTimeout(() => {
      this.hide()
    }, 5000)
  }
}
